import formBaseMongoMixin from  '../../../components/form/form-base-mongo'
import {calculationOffline} from "../../../api/api-offline-endpoints";
import regionalHelperMixin from './regional-helper-mixin'

const moneyValidationPattern = '^(\\d*((\\.\\d{0,1}))?(\\d))$'

export default {
  mixins: [regionalHelperMixin, formBaseMongoMixin],
  data: () => ({
    tableErrors: {
      transportCosts: null,
      grossRevenue: null,
      tariffsConsiderSent: null
    }
  }),
  destroyed () {
    this.clearTable()
  },
  mounted () {
    this.update()
  },
  watch: {
    'fields': {
      handler: 'onFields',
      deep: true
    }
  },
  methods: {
    afterValidateTariffsConsiderSent (ctx, model, errors, els) {
      let reqIFields = [
        'v_waste_i_1',
        'm_waste_i_1'
      ]
      let reqIFilled = this.checkFieldsIsFilled(model, reqIFields)
      let reqNegativeIFields = [
        'v_waste_i_n1', 'v_waste_i_n1', 'v_waste_i_n1', 'v_waste_i_n1',
        'm_waste_i_n1', 'm_waste_i_n4', 'm_waste_i_n4', 'm_waste_i_n4'
      ]
      let reqNegativeIFilled = this.checkFieldsIsFilled(model, reqNegativeIFields)
      if (reqIFilled.isFilled || reqNegativeIFilled.isFilled) {
        return errors
      }
      if (!reqIFilled.isFilled && !reqNegativeIFilled.isFilled) {
        reqIFilled.dontFilled.forEach(fName => {
          errors[fName] = 'Заполните поле'
        })
      } else {
        reqNegativeIFilled.dontFilled.forEach(fName => {
          errors[fName] = 'Заполните поле'
        })
      }
      console.log('errors', errors)
      return errors
    },
    checkFieldsIsFilled (model, fields) {
      let isFilled = true
      let dontFilled = []
      for (let i = 0; i < fields.length; i++) {
        if (!model[fields[i]]) {
          isFilled = false
          dontFilled.push(fields[i])
        }
      }
      return {isFilled, dontFilled}
    },
    onFields () {
      console.log('onFields', this.fields)
    },
    additionalValidate: async function (hasError = false, errors = {}) {
      await this.validateDataInTables(hasError, errors)
      return Promise.resolve(1)
    },
    afterPrepareFieldsForSend (fields = {}) {
      fields = this.putTablesDataToFieldsForSend(fields)
      return fields
    },
    update () {
      this.updateDataInTables()
      this.fields = Object.assign({}, this.item)
    }
  },
  computed: {
    countVMRequired () {
      let reqFields = [
        'v_waste_i', 'v_waste_i_1', 'v_waste_i_2', 'v_waste_i_3',
        'm_waste_i', 'm_waste_i_1', 'm_waste_i_2', 'm_waste_i_3'
      ]
      let fields = this.fields
      let isReq = false
      for (let i = 0; i < reqFields.length; i++) {
        if (!fields[reqFields[i]]) {
          isReq = true
          break
        }
      }
      return isReq
    },
    countFourYearsRequired () {
      return !this.countVMRequired
    },
    tariffsConsiderSentDataUrl () {
      return calculationOffline.tariffsConsiderSentTable(this.$route.name)
    },
    tariffsConsiderSent () {
      return this.$store.getters.readUrlEndpoint(this.tariffsConsiderSentDataUrl).data
    },
    transportCostsDataUrl () {
      return calculationOffline.transportCostsTable(this.$route.name)
    },
    transportCosts () {
      return this.$store.getters.readUrlEndpoint(this.transportCostsDataUrl).data
    },
    grossRevenueDataUrl () {
      return calculationOffline.grossRevenueTable(this.$route.name)
    },
    grossRevenue () {
      return this.$store.getters.readUrlEndpoint(this.grossRevenueDataUrl).data
    },
    enableOnAdd () {
      return []
    },
    tariffsConsiderSentAttributes () {
      return {
        operatorName: {
          label: 'Оператор',
          validationRulePattern: '(\\.*)',
          placeholder: 'Введите название'
        },
        operatorObjectName: {
          label: 'Объекта оператора',
          validationRulePattern: '(\\.*)',
          placeholder: 'Введите название'
        },
        tariff: {
          label: 'Тариф',
          validationRulePattern: moneyValidationPattern,
          placeholder: '0.00',
          required: true
        },
        tariffSurcharge: {
          label: 'Надбавка к тарифу',
          validationRulePattern: moneyValidationPattern,
          placeholder: '0.00'
        },
        v_waste_i_1: {
          label: 'V отходов (i+1) год'
        },
        m_waste_i_1: {
          label: 'M отходов (i+1) год'
        },
        v_waste_i: {
          label: 'V отходов (i) год'
        },
        m_waste_i: {
          label: 'M отходов (i) год'
        },
        v_waste_i_n1: {
          label: 'V отходов (i-1) год'
        },
        m_waste_i_n1: {
          label: 'M отходов (i-1) год'
        },
        v_waste_i_n2: {
          label: 'V отходов (i-2) год'
        },
        m_waste_i_n2: {
          label: 'M отходов (i-2) год'
        },
        v_waste_i_n3: {
          label: 'V отходов (i-3) год'
        },
        m_waste_i_n3: {
          label: 'M отходов (i-3) год'
        },
        v_waste_i_n4: {
          label: 'V отходов (i-4) год'
        },
        m_waste_i_n4: {
          label: 'M отходов (i-5) год'
        }
      }
    },
    transportCostsAttributes () {
      return {
        index: {
          label: 'Показатель',
          validationRulePattern: '(\\.*)',
          placeholder: 'Введите название',
          required: true
        },
        val_i: {
          required: true,
          label: 'i год',
          placeholder: ' ',
        },
        val_i_1: {
          label: 'i + 1 год',
          placeholder: ' ',
          required: true
        }
      }
    },
    grossRevenueAttributes () {
      return {
        operatorName: {
          label: 'Оператор',
          validationRulePattern: '(\\.*)',
          placeholder: 'Введите название'
        },
        operatorObjectName: {
          label: 'Объекта оператора',
          validationRulePattern: '(\\.*)',
          placeholder: 'Введите название'
        },
        tariff: {
          label: 'Тариф',
          validationRulePattern: moneyValidationPattern,
          placeholder: '0.00'
        },
        tariffSurcharge: {
          label: 'Надбавка к тарифу',
          validationRulePattern: moneyValidationPattern,
          placeholder: '0.00'
        },
        v_waste_prev: {
          label: 'V отходов (в куб. м.) пир установ. тарифов'
        },
        m_waste_prev: {
          label: 'M отходов (в тоннах) при установ. тарифов'
        },
        v_waste_fact: {
          label: 'V отходов (в куб. м.) факт'
        },
        m_waste_fact: {
          label: 'M отходов (в тоннах) факт'
        }
      }
    },
    items () {
      return this.$store.getters.readUrlEndpoint(this.getItemsEndpoint(this.$route))
    }
  },
  asyncData ({store, route, fromRoute, methods}) {
    let promises = []

    promises.push(store.dispatch('updateUrlEndpoint', {endpoint: methods.getItemsEndpoint(route, fromRoute)}))
    promises.push(store.dispatch('updateUrlEndpoint', {endpoint: methods.getItemEndpoint(route, fromRoute)}))

    if (promises.length === 0) {
      return Promise.resolve(1)
    }

    return Promise.all(promises)
  }
}
